import MenuPage from "./Components/MenuPage";
function App(){
    return <MenuPage />
}

export default App;